// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconSearch: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="currentColor">
            <path
                fill="currentColor"
                d="M386.825593,748.986915 L381.574616,743.735938 C382.732429,742.385156 383.404109,740.637305 383.404109,738.71875 C383.404109,734.454883 379.948113,731 375.685359,731 C371.422605,731 368,734.455996 368,738.71875 C368,742.981504 371.455633,746.4375 375.68536,746.4375 C377.603172,746.4375 379.353622,745.733907 380.702547,744.576465 L385.953523,749.827442 C386.101961,749.940625 386.254109,750 386.406258,750 C386.558407,750 386.710109,749.942035 386.825965,749.826032 C387.059382,749.595508 387.059382,749.216992 386.825593,748.986915 L386.825593,748.986915 Z M375.718758,745.25 C372.08575,745.25 369.187507,742.318359 369.187507,738.71875 C369.187507,735.119141 372.08575,732.1875 375.718758,732.1875 C379.351766,732.1875 382.250008,735.085742 382.250008,738.71875 C382.250008,742.351758 379.318367,745.25 375.718758,745.25 Z"
                transform="translate(-368 -731)"
            />
        </svg>
    );
};

export default React.memo(IconSearch);
